import React, { useEffect, useState } from 'react';

import { APP } from '../captivision.config';
import { CVFavicon, useCaptiVisionTheme } from '../shell.component';
import { fill, useCVLanguage } from '../i18n/language.component';

import '../captivision.styles.scss';

// Where a CaptiVision Host pairing code lands when it is scanned with the
// iPhone's Camera app. With CaptiVision Client installed, iOS opens the app
// instead and this page never loads - that hand-off is the
// apple-app-site-association file in public/.well-known. Without it, the page
// sends the person to the App Store.
//
// The session's details are in the address after "#". Browsers never send that
// part to the server; it is read here only to offer "Open it and join", and is
// taken out of the browser's history before leaving. Unlisted, like the tester
// instructions: nothing on the site links here. It is in the reader's language,
// since whoever scanned the code may not read English.

// the app's own scheme, for someone who has the app but opened the code in a browser
const joinLink = session => `captivision://join?${session}`;

// keep the page out of search results, and send no referrer to the App Store
const useHeadMeta = () => {
    useEffect(() => {
        const tags = [
            ['robots', 'noindex'],
            ['referrer', 'no-referrer']
        ].map(([name, content]) => {
            const meta = document.createElement('meta');
            meta.name = name;
            meta.content = content;
            document.head.appendChild(meta);
            return meta
        })

        return () => tags.forEach(meta => meta.remove())
    }, [])
}

const CaptiVisionJoin = () => {
    useCaptiVisionTheme()
    useHeadMeta()
    const { t } = useCVLanguage();
    const join = t.join;

    // read once, before the address is cleaned below
    const [session] = useState(() => window.location.hash.length > 1 ? window.location.hash.slice(1) : '');

    useEffect(() => {
        document.title = `${join.title} | ${APP.name}`
    }, [join.title])

    useEffect(() => {
        try {
            window.history.replaceState(window.history.state, '', window.location.pathname);
        } catch (error) {
            // nothing to clean if history is unavailable
        }

        window.location.replace(APP.clientAppStoreUrl);

        return () => { document.title = APP.name }
    }, [])

    return (
        <div className="captivision cv-join">
            <CVFavicon />
            <main className="cv-doc">
                <header className="cv-dochead">
                    <span className="cv-eyebrow"> {join.eyebrow} </span>
                    <h1> {join.heading} </h1>
                    <p className="cv-lede"> {join.lede} </p>
                </header>
                <p>
                    <a className="cv-btn cv-btn-accent" href={APP.clientAppStoreUrl}> {join.store} </a>
                </p>
                {/* offered only if the App Store did not open */}
                {session
                    ? <p> {fill(join.open, { link: <a href={joinLink(session)}>{join.openLink}</a> })} </p>
                    : null}
            </main>
        </div>
    )
}

export default CaptiVisionJoin;
